import styled from 'styled-components'

export const Button = styled.button`
    border: 1px solid #ccc;
    padding: 1rem;
    font-size: 1.2rem;
    font-weight: bold;
    color: #fff;
    background-color: blueviolet;
    border-radius: 5px; 
    cursor: pointer;
    transition: all 0.3s;
`
